import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import logo from '../assets/cross1.png'
import * as Api from '../Services/Api'
import { useAuth } from '../Context/AuthContext'
import ThemeToggle from '../components/ThemeToggle'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()
  const { login } = useAuth()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    if (urlParams.get('logout') === 'true') {
      localStorage.removeItem('token')
      return
    }

    const existingToken = localStorage.getItem('token')
    if (!existingToken) return

    const restoreSession = async () => {
      try {
        await Api.fetchCantiques()
        login(existingToken)
        const dest = location.state?.from?.pathname || '/admin'
        navigate(dest, { replace: true })
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem('token')
        }
      }
    }

    restoreSession()
  }, [navigate, location, login])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const res = await Api.login({ username: email.trim(), password })
      localStorage.setItem('token', res.data.token)
      login(res.data.token)

      if (remember) {
        localStorage.setItem('rememberAdmin', 'true')
      } else {
        localStorage.removeItem('rememberAdmin')
      }

      toast.success('Connexion réussie')
      const dest = location.state?.from?.pathname || '/admin'
      navigate(dest, { replace: true })
    } catch (err) {
      console.error('login error', err)
      toast.error(err.response?.data?.message || 'Échec de la connexion')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="login">
      <ThemeToggle className="login__themeToggle" />
      <div className="login__image"><img src={logo} alt="La croix" className="login__image__img" /></div>
      <div className="login__container">
        <div className="login__left">
          <div className="login__brand">
            <span className="login__brandIcon">
              <img src={logo} alt="La croix" className="login__brandIcon__Icon" />
            </span>
            <span className="login__brandText">
              Atmosphere-ALCM<br />
              <small>Cantiques</small>
            </span>
          </div>
        </div>
        <div className="login__right">
          <form className="login__form" onSubmit={handleSubmit}>
            <h2 className="login__formTitle">Connexion — Administration</h2>
            <label className="login__label">
              Email
              <input
                className="login__input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </label>
            <label className="login__label">
              Mot de passe
              <input
                className="login__input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>
            <div className="login__options">
              <label className="login__remember">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                />
                Se souvenir de moi
              </label>
            </div>
            <button type="submit" className="login__button" disabled={isSubmitting}>
              {isSubmitting ? 'Connexion...' : 'Se connecter'}
            </button>
            <p className="login__signup">
              Pas de compte ? Contactez l&apos;administrateur.
            </p>
          </form>
        </div>
      </div>
      <footer className="login__footer">© 2026 Atmosphere-ALCM</footer>
    </div>
  )
}

export default Login
